import pkg from '../../package.json';

/**
 * NPM export of the version number
 */
export const app_version = pkg.version

/**
 * The toast options in case of a success toast
 */
export const TOAST_SUCCESS_OPTIONS = {
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: "fas fa-check",
    rtl: false
}

export const IMAGE_FILE_EXTENSIONS = ["png","jpg","jpeg","svg","gif","webp","bmp"]
export const EXCEL_FILE_EXTENSIONS = ["xlsx","xls","xlsm","xlt","xltx","xltm"]
export const WORD_FILE_EXTENSIONS = ["doc","docx","dot","dotx","dotm"]
export const PPT_FILE_EXTENSIONS = ["ppt","pptx","pptm","pot","potx","potm"]
export const ARCHIVE_FILE_EXTENSIONS = ["zip","rar","7z","tar","gz","bz2"]

/**
 * The settings for the leaflet map
 */
export const LEAFLET_SETTINGS = {
    zoomControl: true,
    zoom:1,
    zoomAnimation:true,
    fadeAnimation:true,
    markerZoomAnimation:true,
    worldCopyJump: true,
    maxBoundsViscosity: 1.0,
}

/**
 * The settings of the leaflet open streetmap layer
 */
export const LEAFLET_OPEN_STREET_MAP_SETTINGS = {
    maxZoom: 20,
    minZoom: 3,
    subdomains:['mt0','mt1','mt2','mt3'],
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
}

/**
 * The url of the open streetmap tile layer
 */
export const LEAFLET_OPEN_STREET_MAP_URL = "https://tile.openstreetmap.org/{z}/{x}/{y}.png"

/**
 * Maps device types to their icons
 */
export const deviceTypeDetails = {
    appliance: {
        title: "MX",
        img: "/assets/img/devices/MX.svg"
    },
    switch: {
        title: "MS",
        img: "/assets/img/devices/MS.svg"
    },
    wireless: {
        title: "MR",
        img: "/assets/img/devices/MR.svg"
    },
    camera: {
        title: "MV",
        img: "/assets/img/devices/MV.svg"
    },
    sensor: {
        title: "MT",
        img: "/assets/img/devices/MT.svg"
    },
    cellularGateway: {
        title: "MG",
        img: "/assets/img/devices/MG.svg"
    },
}


/**
 * Maps Verkada device types to their icons
 */
export const verkadaDeviceTypeDetails = {
    camera: {
        title: "Cameras",
        img: "/assets/img/verkada/devices/camera.svg",
        url: "/verkada/cameras",
        userPermissions: [[
            '@pollux.view.verkada.cameras'
        ]],
        modulePermissions: [[
            'VERKADA_MAIN',
            'VERKADA_CAMERA'
        ]],
        count: 0
    },
    accessController: {
        title: "Access Controllers",
        img: "/assets/img/verkada/devices/acu.svg",
        url: "/verkada/controller-groups",
        userPermissions: [[
            '@pollux.view.verkada.access'
        ]],
        modulePermissions: [[
            'VERKADA_MAIN',
            'VERKADA_ACCESS'
        ]],
        count: 0
    },
    door: {
        title: "Doors",
        img: "/assets/img/verkada/devices/door.svg",
        url: "/verkada/controller-groups",
        userPermissions: [[
            '@pollux.view.verkada.access'
        ]],
        modulePermissions: [[
            'VERKADA_MAIN',
            'VERKADA_ACCESS'
        ]],
        count: 0
    },
}
